import { render, staticRenderFns } from "./iosGw.vue?vue&type=template&id=01224e8d&scoped=true&"
import script from "./iosGw.vue?vue&type=script&lang=js&"
export * from "./iosGw.vue?vue&type=script&lang=js&"
import style0 from "./iosGw.vue?vue&type=style&index=0&id=01224e8d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01224e8d",
  null
  
)

export default component.exports